import * as React from 'react';
import { useMemo } from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import {
  useVideoDeletesContext,
  VideoDeletesContextProvider,
} from 'lib/context';
import { PreLoader } from './PreLoader';

const Wrapper = () => {
  const { state, dispatch } = useVideoDeletesContext();

  return useMemo(() => <PreLoader {...state} dispatch={dispatch} />, [
    state.videoDelete,
    state.loading,
  ]);
};

export const VideoDeletion = () => (
  <VideoDeletesContextProvider>
    <DocumentHead title="Video Expiration" />
    <PageTemplate main={<Wrapper />} />
  </VideoDeletesContextProvider>
);
